import React from 'react'

const Loader = () => {
  return (
    <div className='w-full h-full flex justify-center items-center'>
        <div class="loader"></div>
    </div>
  )
}

export default Loader